// src/app/core/services/seo.service.ts
import { Injectable } from '@angular/core';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';
import { ConfigAppService } from './config-app.service';

@Injectable({
    providedIn: 'root'
})
export class SeoService {
    constructor(
        private titleService: Title,
        private metaService: Meta,
        private configService: ConfigAppService
    ) { }

    updateSeo(): void {
        this.configService.getConfig().subscribe(config => {
            // Título
            this.titleService.setTitle(config.title);

            // Meta básicas
            this.updateMeta('description', config.description);
            this.updateMeta('keywords', 'informática, reparación, notebooks, componentes, insumos,producto,limpieza,comestibles');

            // Canonical
            this.updateMeta('canonical', config.url);

            // Open Graph
            this.updateMeta('og:title', config.title);
            this.updateMeta('og:description', config.description);
            this.updateMeta('og:url', config.url);
            this.updateMeta('og:image', config.logo);
            this.updateMeta('og:image:secure_url', config.logo);
            this.updateMeta('og:image:type', 'image/jpeg');
            this.updateMeta('og:image:width', '420');
            this.updateMeta('og:image:height', '420');
            this.updateMeta('og:locale', config.og.locale);
            this.updateMeta('og:type', config.og.type);
            this.updateMeta('og:site_name', config.appName);

            // Twitter Card
            this.updateMeta('twitter:card', config.twitter.card);
            this.updateMeta('twitter:site', config.twitter.site);
            this.updateMeta('twitter:creator', config.twitter.creator);
            this.updateMeta('twitter:title', config.title);
            this.updateMeta('twitter:description', config.description);
            this.updateMeta('twitter:image', config.logo);

            // Favicon ya está en index.html (estático)
        });
    }

    private updateMeta(name: string, content: string): void {
        const tag: MetaDefinition = { name, content };
        if (this.metaService.getTag(`name='${name}'`)) {
            this.metaService.updateTag(tag);
        } else {
            this.metaService.addTag(tag);
        }
    }

    // Método para actualizar en páginas específicas (ej: producto)
    updatePageSeo(title: string, description: string, image?: string): void {
        this.titleService.setTitle(title);
        this.updateMeta('description', description);
        if (image) {
            this.updateMeta('og:image', image);
            this.updateMeta('twitter:image', image);
        }
    }
}